// extracted by mini-css-extract-plugin
module.exports = {"search-bar":"index_search-bar__mddg5","icon":"index_icon___nsum","input":"index_input__KcvL1"};